import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import cx from 'classnames2';
import React, { forwardRef } from 'react';
import { Illustration } from '../Illustration';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';
import { Tooltip } from '../Tooltip';
import styles from './NavigationBar.scss';
export var ProductSwitcher = function ProductSwitcher() {
  return React.createElement(Popover, {
    id: "product-switcher",
    placement: "right-end",
    closeOnBlur: true,
    returnFocusOnClose: false
  }, React.createElement(PopoverTrigger, null, React.createElement("button", {
    className: styles.productSwitcherContainer,
    id: "product-switcher",
    tabIndex: 0
  }, React.createElement(Illustration, {
    className: styles.productSwitcher,
    illustration: "product-switcher"
  }), React.createElement("span", {
    className: styles.productSwitcherLabel
  }, "OpenGov Suite"))), React.createElement(PopoverContent, {
    className: styles.productSwitcherMenu
  }, React.createElement("span", {
    className: styles.label
  }, "Switch product"), React.createElement("ul", null, React.createElement("li", null, "Budget & Reporting"), React.createElement("li", null, "Citizen Services"), React.createElement("li", null, "Open Data"), React.createElement("li", null, "OpenGov Financials"), React.createElement("li", null, "Open Town Hall"))));
};
export var NavigationBarUserMenuPopover = function NavigationBarUserMenuPopover(_ref) {
  var currentEntity = _ref.currentEntity,
      session = _ref.session,
      onLogout = _ref.onLogout;
  return React.createElement(Popover, {
    id: "user-menu",
    placement: "right-end",
    closeOnBlur: true,
    returnFocusOnClose: false
  }, React.createElement(PopoverTrigger, null, React.createElement("button", {
    className: styles.user
  }, React.createElement("div", {
    className: styles.userIcon,
    style: {
      backgroundImage: "url(".concat(session.avatar, ")"),
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }, session.avatar ? null : "".concat(session.first_name[0]).concat(session.last_name[0])))), React.createElement(PopoverContent, {
    className: styles.userMenu
  }, React.createElement("span", {
    className: styles.label
  }, session.email), React.createElement("ul", null, React.createElement("li", null, React.createElement("a", {
    href: "/controlpanel#/".concat(currentEntity, "/manage/users/").concat(session.id)
  }, "Profile")), React.createElement("li", null, React.createElement("a", {
    href: "#",
    onClick: onLogout
  }, "Logout")))));
}; // tslint:disable-next-line:variable-name

var _NavigationBarAppLink = function _NavigationBarAppLink(_ref2, ref) {
  var isActive = _ref2.isActive,
      name = _ref2.name,
      illustration = _ref2.illustration,
      href = _ref2.href,
      rest = _objectWithoutProperties(_ref2, ["isActive", "name", "illustration", "href"]);

  return React.createElement("a", Object.assign({
    ref: ref,
    href: href,
    className: cx(styles.app, isActive && styles.active)
  }, rest), React.createElement(Illustration, {
    className: styles.appIcon,
    illustration: "".concat(illustration, "-inactive"),
    ariaHidden: true
  }), React.createElement(Illustration, {
    className: cx(styles.appIcon, styles.active),
    illustration: "".concat(illustration, "-active"),
    ariaHidden: true
  }), name);
}; // hack because zeus blows up when forwardRef is used like it should be


export var NavigationBarAppLink = function () {
  return forwardRef(_NavigationBarAppLink);
}();
export var NavigationBarBottom = function NavigationBarBottom(_ref3) {
  var children = _ref3.children;
  return React.createElement("div", {
    className: styles.bottom
  }, children);
};
export var NavigationBarBottomLink = function NavigationBarBottomLink(_ref4) {
  var href = _ref4.href,
      id = _ref4.id,
      children = _ref4.children,
      isExternal = _ref4.isExternal;
  return React.createElement("a", {
    href: href,
    id: id ? id : null,
    className: styles.link,
    tabIndex: 0,
    target: isExternal ? '_blank' : null
  }, children);
};
export var appLinks = [{
  name: 'Network',
  tooltipContent: 'Explore and learn from other OpenGov customers',
  illustration: 'app-network',
  url: '/network/',
  activePaths: ['/network']
}, {
  name: 'Reports',
  tooltipContent: 'Create and manage reports and dashboards',
  illustration: 'app-reporting',
  url: '/reports#/',
  activePaths: ['/reports', '/reporting', '/dashboards']
}, {
  name: 'Budgets',
  tooltipContent: 'Create and manage budgets and proposals',
  illustration: 'app-budget',
  url: '/budgets/',
  activePaths: ['/budgets']
}, {
  name: 'Stories',
  tooltipContent: 'Create and manage stories (Published, Drafts and Templates)',
  illustration: 'app-stories',
  url: '/stories/',
  activePaths: ['/stories']
}, {
  name: 'Portal',
  tooltipContent: 'Create and manage your public transparency site',
  illustration: 'app-portal',
  url: '/portal/',
  activePaths: ['/portal']
}, {
  name: 'Initiatives',
  tooltipContent: 'Create and manage strategic initiatives',
  illustration: 'app-si',
  url: '/strategic-initiatives/',
  activePaths: ['/strategic-initiatives']
}, {
  name: 'Data',
  tooltipContent: 'Create and manage chart of accounts / upload data',
  illustration: 'app-data',
  url: '/data_manager/',
  activePaths: ['/data_manager']
}];
export var mapControlPanelMenuItemsToApps = function mapControlPanelMenuItemsToApps(menuItems, session) {
  if (menuItems) {
    return menuItems.map(function (item) {
      var app = appLinks.find(function (i) {
        return i.name === item.name;
      });
      return app || null;
    }).filter(function (i) {
      return !!i;
    });
  } else if (session && session.control_panel_menu_items) return session.control_panel_menu_items.map(function (item) {
    var app = appLinks.find(function (i) {
      return i.name === item.name;
    });
    return app || null;
  }).filter(function (i) {
    return !!i;
  });else {
    return [];
  }
};

var isAppActive = function isAppActive(currentAppPathname, app) {
  var _iterator = _createForOfIteratorHelper(app.activePaths),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var appUrl = _step.value;

      if (currentAppPathname.indexOf(appUrl) > -1) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};

export var NavigationBar = function NavigationBar(_ref5) {
  var currentAppPathname = _ref5.currentAppPathname,
      currentEntity = _ref5.currentEntity,
      menuItems = _ref5.menuItems,
      session = _ref5.session,
      onLogout = _ref5.onLogout;
  return React.createElement(React.Fragment, null, React.createElement("a", {
    className: styles.skipLink,
    href: "#main"
  }, "Skip to main content"), React.createElement("header", {
    className: styles.navigation
  }, React.createElement("div", {
    className: styles.logoContainer
  }, React.createElement(Illustration, {
    illustration: "opengov-logo",
    height: 40,
    width: 40,
    ariaLabel: "OpenGov"
  })), React.createElement("div", {
    className: styles.appName
  }, "Budget & Reporting"), React.createElement("div", {
    className: styles.divider,
    role: "separator"
  }), React.createElement("nav", null, React.createElement("ul", {
    className: styles.appList
  }, mapControlPanelMenuItemsToApps(menuItems, session).map(function (app) {
    return React.createElement("li", {
      key: app.name
    }, React.createElement(Tooltip, {
      className: styles.appTooltip,
      content: app.tooltipContent,
      placement: "right",
      ariaLabel: app.tooltipContent
    }, React.createElement(NavigationBarAppLink, {
      isActive: isAppActive(currentAppPathname, app),
      name: app.name,
      illustration: app.illustration,
      href: "".concat(app.url).concat(currentEntity)
    })));
  })), React.createElement(NavigationBarBottom, null, session && session.id && React.createElement(NavigationBarUserMenuPopover, {
    currentEntity: currentEntity,
    session: session,
    onLogout: onLogout
  }), React.createElement(NavigationBarBottomLink, {
    href: "/controlpanel#/".concat(currentEntity, "/manage/settings")
  }, "Settings"), React.createElement(NavigationBarBottomLink, {
    id: "walkme-navigation-help",
    isExternal: true,
    href: "https://opengov.zendesk.com/hc/en-us"
  }, "Help")))));
};